import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 9,
	viewBox: "0 0 16 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.01 3.5H0V5.5H12.01V8.5L16 4.5L12.01 0.5V3.5Z",
		fill: "#333333"
	})
});
export default SvgArrowRightAlt;
